import { Card } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { getInvestorLocale } from '@app/utils/getInvestorLocale';
import FilterPopup from './filter/FilterPopup';
const HeaderMobile = ({ onFilterChange, filters, showCreditScore, showInvestmentStatus }) => {
    const { t } = useTranslation();
    const locale = getInvestorLocale();
    return (<Card className="flex flex-col gap-4">
            <FilterPopup isMobile onFilterChange={onFilterChange} filters={filters} showCreditScore={showCreditScore} showInvestmentStatus={showInvestmentStatus}/>
            <a href={`https://www.paysera.com/v2/${locale}/legal`} target="_blank" className="text-action-primary-initial body-m font-medium" rel="noreferrer">
                {t('financing.investing_page_table.legal_info')}
            </a>
        </Card>);
};
export default HeaderMobile;
